"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsUserActive = useIsUserActive;
exports.useUserActivityEffect = useUserActivityEffect;
const react_1 = require("react");
const react_idle_timer_1 = require("react-idle-timer");
// User is considered as idle if they have not done anything for 5 minutes
const USER_IDLE_TIMEOUT = 5 * 60 * 1000;
/**
 * Hook that returns whether the user is considered active or idle
 * @returns true if user is considered as active
 */
function useIsUserActive() {
    const [isUserActive, setIsUserActive] = (0, react_1.useState)(true);
    const onUserActive = (0, react_1.useCallback)(() => {
        setIsUserActive(true);
    }, [setIsUserActive]);
    const onUserIdle = (0, react_1.useCallback)(() => setIsUserActive(false), [setIsUserActive]);
    (0, react_idle_timer_1.useIdleTimer)({
        onActive: onUserActive,
        onIdle: onUserIdle,
        timeout: USER_IDLE_TIMEOUT,
    });
    return isUserActive;
}
/**
 * Schedule a callback to occur whenever the user's activity status changes
 *
 * @param callback to trigger when user's activity status changes
 */
function useUserActivityEffect(callback) {
    const ref = (0, react_1.useRef)(callback);
    ref.current = callback;
    const onUserActive = (0, react_1.useCallback)(() => {
        ref.current(true);
    }, []);
    const onUserIdle = (0, react_1.useCallback)(() => ref.current(false), []);
    (0, react_idle_timer_1.useIdleTimer)({
        onActive: onUserActive,
        onIdle: onUserIdle,
        timeout: USER_IDLE_TIMEOUT,
    });
}
//# sourceMappingURL=use_user_activity.js.map